import App from '../app'
import Axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, Axios)
// Vue.axios.defaults.baseURL = App.url + '/api/v1'
Vue.axios.defaults.baseURL = App.url + '/public/api/v1'
// Vue.axios.defaults.baseURL = App.url + '/api/v1'
Vue.axios.defaults.headers.common['Accept'] = 'application/json'
Vue.axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

// Add a request interceptor
Vue.axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.info(`REQUEST INTERCEPTOR - CONFIG \n ${JSON.stringify(config)}`)
    return config
  },
  function(error) {
    // Do something with request error
    // console.error(`REQUEST INTERCEPTOR - ERROR \n ${JSON.stringify(error)}`)
    return Promise.reject(error)
  }
)

// Add a response interceptor
Vue.axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // let token = this.axios._getHeaders.call(this, response).Authorization
    // console.info(`RESPONSE INTERCEPTOR - TOKEN \n ${token}`)
    // console.info(`RESPONSE INTERCEPTOR - RESPONSE \n ${JSON.stringify(response.data)}`)
    return response
  },
  function(error) {
    // Do something with response error
    // alert(error)
    // console.error(`RESPONSE INTERCEPTOR - ERROR \n`)
    if (error.response) {
      // console.info(error.response.status)
      // console.info(error.response.data)
      // console.info(error.response.headers)
    } else if (error.request) {
      // console.info(`REQUEST: ${JSON.stringify(error.request)}`)
    } else {
      // console.info(`MESSAGE: ${JSON.stringify(error.message)}`)
    }
    return Promise.reject(error)
  }
)

export default {
  get(relativePath, callback, params) {
    Axios.get(relativePath, { params: params })
      .then(response => {
        // console.log(relativePath)
        // this.$app.log(response.data)
        callback(response.data.data)
      })
      .catch(error => {
        if (error.response) {
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js